/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// debugger;
window.addEventListener('load', (event) => {

  try{
  var card_info = document.getElementsByClassName("card_info");
  var seeBtn = document.getElementsByClassName("seeit_action");
      if(seeBtn.length === 0){
        card_info[0].style.display = "none";
      }
  }catch(e){
  }
  try{
  // const div = document.querySelector('div');
   if(document.getElementsByClassName('sample-hidden').length === 1){  
    document.getElementsByClassName("card_info_sample")[0].style.display = "none";
   }  
  }catch(e){
  }
   
   
});


jQuery('.product-gallery__thumbnail').click(function() {
  setTimeout(function() {
    var selected_variant = jQuery('.variant-swatch .variant-swatch__item').attr('title');
    var selected_attribute = jQuery('.product-gallery__thumbnail.is-nav-selected .image--fade-in').attr('alt');
    if (selected_variant == selected_variant) {
        jQuery('.variant-swatch .variant-swatch__item[title="'+selected_attribute+'"] img').trigger('click');
    }
}, 500);
});

 $(document).ready(function() {
        var timeout;
        function getWidth() {
            var width = $(window).width();
            current = $('.header-slide.active');
            current.removeClass('active'); // Remove active class from all elements
            if (width < 991) {
              if(current.next().index() == -1 ){
                $('.header-slide:first-child').addClass('active');
              }else{
                current.next().addClass('active'); 
              }
            } 
        }
        interval = setInterval(getWidth, 3000);
        $('.header-slide').hover(
            function() {
                clearInterval(interval); // Clear the interval when hovering
            },
            function() {
                interval = setInterval(getWidth, 3000); // Restart interval when mouse leaves
            }
        );
   
         $(window).resize(function() {
            clearInterval(interval); // Clear the interval to prevent multiple intervals running simultaneously
            getWidth(); // Execute getWidth immediately when window is resized
            interval = setInterval(getWidth, 3000); // Set new interval after window is resized
        });
    });

